import type { Messages } from '../messages.js'

/** Greek. `κινήσεις` for flips, because the meter counts what an action costs you. */
export const el: Messages = {
  tag: 'el',

  readingDictionary: 'Ανάγνωση λεξικού…',
  noWordList: 'Δεν υπάρχει λίστα λέξεων για «{language}». Δημιουργήστε την:  pnpm dictionary build',
  emptyWordList: 'Η λίστα λέξεων για «{language}» είναι κενή.',

  flips: 'κινήσεις',
  score: 'βαθμοί',
  words: 'λέξεις',
  round: 'γύρος',
  ticksLeftLabel: 'Χρόνος που απομένει στον γύρο',
  typeAWord: 'γράψτε μια λέξη',
  tapPrompt: 'αγγίξτε για να πάρετε ή να δώσετε, μετά {action}',

  boardOfTiles: 'Ταμπλό με {n} πλακίδια',
  faceDown: 'κλειστό',
  wildCard: 'μπαλαντέρ',
  wildKey: 'οποιοδήποτε γράμμα',
  letterReplaced: 'Το {from} έγινε {to}',
  letterSwap: 'ΑΛΛΑΓΗ ΓΡΑΜΜΑΤΟΣ!',
  spentTile: 'χρησιμοποιημένο πλακίδιο',
  hiddenWhilePaused: 'κρυμμένο στην παύση',
  letterInWord: '{letter}, {position}ο γράμμα της λέξης',

  completeWord: 'Υποβολή λέξης',
  completeShort: 'Υποβολή',
  reset: 'Καθαρισμός',
  pause: 'Παύση',
  resume: 'Συνέχεια',
  newGame: 'Νέο παιχνίδι',
  paused: 'Σε παύση',
  outOfFlips: 'Τέλος οι κινήσεις',
  finalResult: '{score} βαθμοί από {words} σε {rounds}',
  playAgain: 'Ξανά',
  share: 'Κοινοποίηση',
  shareCopied: 'Αντιγράφηκε.',
  shareSelect: 'Αντιγράψτε αυτό:',

  lettersSelect: 'τα γράμματα επιλέγουν',
  keysWild: 'παίρνεται όταν γράφετε γράμμα που δεν δείχνει κανένα πλακίδιο',
  clearsEvery: 'αφαιρεί όλα τα επιλεγμένα {letter}',
  undoLastLetter: 'αναιρεί το τελευταίο γράμμα',
  noWordsYet: 'Καμία λέξη ακόμη.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'βρέθηκε ήδη',
  reasonTooShort: 'πολύ μικρή',
  reasonNotAWord: 'δεν είναι λέξη',
  reasonAllFound: 'τα έχετε ήδη όλα',
  noSuchLetterUp: 'κανένα {letter} ανοιχτό',
  nothingUp: 'τίποτα ανοιχτό',
  letterHidden: 'ένα γράμμα κρύφτηκε',
  shuffled: 'ανακατεύτηκε',
  shuffledAndBilled: 'ανακατεύτηκε, χρεώθηκαν {flips} αχρησιμοποίητες κινήσεις',
  tooFewLetters: 'Έμειναν πολύ λίγα γράμματα',

  gameLanguage: 'γλώσσα',
  interfaceLanguage: 'περιβάλλον',
  dictionarySize: '{common} κοινές από {full} λέξεις',
  filterLanguages: 'Αναζήτηση γλωσσών',
  noMatches: 'Καμία αντιστοιχία',

  nerdMode: 'λειτουργία λεπτομερειών',
  rules: 'Κανόνες',
  difficulty: 'δυσκολία',
  difficultyNames: { easy: 'εύκολο', medium: 'μέτριο', hard: 'δύσκολο', insane: 'εξοντωτικό' },
  pausedNoBoard: 'Αυτό το παιχνίδι δεν θα μπει στην κατάταξη.',
  about: 'Σχετικά',
  themeLabel: 'θέμα',
  themeNames: { traditional: 'παραδοσιακό', light: 'φωτεινό', contrast: 'υψηλή αντίθεση' },
  tiles: 'πλακίδια (N)',
  secondsPerTick: 'δευτερόλεπτα / χτύπος',
  holdTicks: 'χτύποι αναμονής',
  minWord: 'ελάχιστη λέξη',
  startingFlips: 'αρχικές κινήσεις',
  wildChance: 'πιθανότητα μπαλαντέρ',
  replaceChance: 'πιθανότητα αλλαγής γράμματος',
  hideChance: 'πιθανότητα απόκρυψης γράμματος',
  wordCompleteMode: 'λέξη ολοκληρώθηκε',
  wordCompleteNames: { shuffle: 'ανακάτεμα', spend: 'κατανάλωση', keep: 'διατήρηση' },
  flipEconomy: 'οικονομία κινήσεων',
  flipEconomyNames: {
    none: 'καμία',
    perLetter: 'ανά γράμμα',
    fibonacci: 'φιμπονάτσι',
    overMinimum: 'πάνω από το ελάχιστο',
  },
  repeatedLetterKey: 'πλήκτρο επαναλαμβανόμενου γράμματος',
  keySchemeNames: { cycle: 'κύκλος', advance: 'προώθηση' },
  keySchemeHelp: {
    cycle:
      'Το Α παίρνει το επόμενο ελεύθερο Α και, όταν μπουν όλα στη λέξη, τα αφαιρεί. ' +
      'Shift+Α τα αφαιρεί επίσης.',
    advance: 'Το Α παίρνει το επόμενο ελεύθερο Α. Shift+Α αφαιρεί κάθε Α από τη λέξη.',
  },

  whatThatMeans: 'Τι σημαίνει αυτό',
  factRound: 'ένας γύρος',
  factWholeBoardUp: 'όλο το ταμπλό ανοιχτό',
  factRoundCosts: 'ένας γύρος κοστίζει',
  factFlipsBuy: 'οι αρχικές κινήσεις φτάνουν για',
  factThisBoard: 'αυτό το ταμπλό',
  factBoardHadToAdmit: 'το ταμπλό έπρεπε να επιτρέπει',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, μεγαλύτερη {longest}',
  wordsIncludingOneOf: '{words} με μία από {ceiling}',
  scorelessRounds: '{rounds} χωρίς βαθμούς',

  whatAWordPays: 'Τι αποδίδει μια λέξη',
  columnLetters: 'γράμματα',
  columnCost: 'κόστος',
  columnPoints: 'βαθμοί',
  columnFlips: 'κινήσεις',
  columnNet: 'καθαρό',

  canonicalRules: 'Επίσημοι κανόνες: {difficulty}.',
  customRules: 'Αλλαγή από την προεπιλογή. Τα σκορ με δικούς σας κανόνες δεν κατατάσσονται.',
  applyAndStart: 'Εφαρμογή και νέο παιχνίδι',
  changesNextGame: 'Οι αλλαγές ισχύουν από το επόμενο παιχνίδι.',
  presets: 'Προεπιλογές:',

  start: 'Έναρξη',
  restart: 'Από την αρχή',
  quit: 'Έξοδος',
  quitTitle: 'Έξοδος από αυτό το παιχνίδι;',
  restartTitle: 'Επανεκκίνηση αυτού του παιχνιδιού;',
  restartConfirm: 'Επανεκκίνηση',
  quitConfirm: 'Έξοδος',
  keepPlaying: 'Συνέχεια',
  personalBest: 'Τα καλύτερά σας παιχνίδια',
  newPersonalBest: 'Νέο προσωπικό ρεκόρ.',
  columnRank: '#',
  notRanked: 'Δικοί σας κανόνες, οπότε αυτό το παιχνίδι δεν κατατάσσεται.',
  notRankedPaused: 'Το ρολόι σταμάτησε, οπότε αυτό το παιχνίδι δεν κατατάσσεται.',
  rankOfTotal: '{rank} από {total}',

  howToPlay: 'Πώς παίζεται',

  backToGame: 'Επιστροφή στο παιχνίδι',
  welcomeTitle: 'Καλώς ήρθατε στο Blinkered',
  tutorialSkip: 'Παράλειψη',
  tutorialNext: 'Επόμενο',
  tutorialBack: 'Πίσω',
  tutorialStart: 'Ξεκινήστε να παίζετε',
  tutorialHideAgain: 'Να μην εμφανιστεί ξανά',
  tutorialProgress: '{n} από {total}',
  tutorialSkipTitle: 'Παράλειψη της ξενάγησης;',
  tutGoalTitle: 'Το Blinkered είναι αγώνας δρόμου',
  tutGoalBody:
    'Ξεκινάτε το παιχνίδι με σταθερό αριθμό κινήσεων, και κάθε πλακίδιο που γυρίζει κοστίζει μία κίνηση. Όταν οι κινήσεις τελειώσουν, το παιχνίδι τελειώνει. Οι λέξεις κερδίζουν κινήσεις, και όσο μεγαλύτερη η λέξη, τόσο περισσότερες κινήσεις κερδίζετε.',
  tutSpentBody:
    'Τα γράμματα που χρησιμοποιείτε σε μια λέξη γυρίζουν ανάποδα μέχρι τον επόμενο γύρο. Μόνο μια αλλαγή γράμματος αλλάζει ποια γράμματα υπάρχουν στο ταμπλό.',
  tutChangeTitle: 'Τα γράμματα μπορεί να αλλάξουν',
  tutSameLetters:
    'Είδατε μια λέξη που δεν προλάβατε να παίξετε; Τα ίδια γράμματα επιστρέφουν στον επόμενο γύρο, ανακατεμένα σε νέες θέσεις.',
  tutPickLetters: 'Πατήστε με τη σειρά τα γράμματα που θέλετε, για να σχηματίσετε μια λέξη.',
  tutMoreTurn:
    'Τα πλακίδια συνεχίζουν να γυρίζουν όσο σκέφτεστε, οπότε μπορεί να έρθει καλύτερο γράμμα.',
  tutTapBack:
    'Πατήσατε λάθος; Πατήστε το ξανά για να το επιστρέψετε. Οποιοδήποτε, όχι μόνο το τελευταίο.',
  tutComplete: 'Πατήστε Ολοκλήρωση όταν η λέξη είναι έτοιμη.',
  htBoardTitle: 'Το ταμπλό',
  htBoardBody:
    'Τα πλακίδια γυρίζουν ένα κάθε φορά, με τυχαία σειρά. Από τα ανοιχτά πλακίδια σχηματίζετε λέξεις.',
  htWordsTitle: 'Οι λέξεις',
  htWordsBody:
    'Σχηματίστε μια λέξη από τα ανοιχτά πλακίδια, γράφοντας ή πατώντας τα γράμματα με τη σειρά.',
  htFlipsTitle: 'Οι κινήσεις',
  htFlipsBody:
    'Κάθε πλακίδιο που γυρίζει κοστίζει μία κίνηση. Μια ολοκληρωμένη λέξη προσθέτει κινήσεις στο σύνολό σας, και οι μεγάλες λέξεις δίνουν περισσότερες. Όταν οι κινήσεις τελειώσουν, το παιχνίδι τελειώνει.',
  htRoundTitle: 'Ο γύρος',
  htRoundBody:
    'Όταν γυρίσει το τελευταίο πλακίδιο του γύρου, όλο το ταμπλό μένει ανοιχτό για μια στιγμή. Μετά τα πλακίδια γυρίζουν ανάποδα και ανακατεύονται, και αρχίζει νέος γύρος.',
  htLanguagesTitle: 'Οι γλώσσες',
  htLanguagesBody:
    '{n}. Κάθε ταμπλό λύνεται με λέξεις που χρησιμοποιούνται στην πράξη. Μια ασυνήθιστη λέξη μετράει κι αυτή, αν τη γνωρίζει το λεξικό.',
  htKeysTitle: 'Το πληκτρολόγιο',
  htWildTitle: 'Οι μπαλαντέρ',
  htWildBody:
    'Μερικές φορές εμφανίζεται ένας μπαλαντέρ αντί για γράμμα. Ο μπαλαντέρ μετράει ως οποιοδήποτε γράμμα σχηματίζει έγκυρη λέξη. Λέξη που έχετε ήδη ολοκληρώσει δεν μετράει.',
  htHideTitle: 'Γράμματα που κρύβονται',
  htHideBody:
    'Στα δυσκολότερα επίπεδα ένα γράμμα που φαίνεται μπορεί να γυρίσει μόνο του και να επιστρέψει αργότερα στον γύρο. Ο χρόνος κερδίζει ένα χτύπο γι’ αυτό, με κόκκινο. Τα γράμματα που έχεις ήδη πάρει δεν γυρίζουν.',
  tutHideBody:
    'Στα δυσκολότερα επίπεδα ένα γράμμα που φαίνεται μπορεί να γυρίσει μόνο του και να επιστρέψει αργότερα στον γύρο. Τα γράμματα που έχεις ήδη πάρει δεν γυρίζουν.',
  htSwapTitle: 'Τα γράμματα αλλάζουν',
  htSwapBody:
    'Μερικές φορές, ανάμεσα στους γύρους, ένα γράμμα αντικαθίσταται από άλλο. Θα δείτε ποιο γράμμα αφαιρέθηκε και ποιο προστέθηκε.',
  htLevelsTitle: 'Τα επίπεδα',
  htLevelEasy:
    'Τα ίδια δώδεκα γράμματα σε όλο το παιχνίδι, οπότε προλαβαίνετε να τα μάθετε και να κρατάτε μια λίστα λέξεων στο μυαλό σας. Τα πλακίδια γυρίζουν αργά και το γεμάτο ταμπλό μένει ορατό αρκετή ώρα για να προλάβετε να διαλέξετε τα γράμματά σας.',
  htLevelMedium:
    'Πού και πού ένα γράμμα αλλάζει, οπότε γίνεται πιο δύσκολο να συγκρατήσετε λέξεις που σκοπεύατε να παίξετε αργότερα. Λιγότερος χρόνος για να δείτε και λιγότερος για να σκεφτείτε.',
  htLevelHard:
    'Οι λέξεις των τριών γραμμάτων παύουν να μετράνε, και ένα γράμμα αλλάζει περίπου κάθε δεύτερο γύρο. Το ταμπλό μόλις που προλαβαίνει να φανεί πριν ανακατευτεί.',
  htLevelInsane:
    'Όλα μαζί, στη μέγιστη ταχύτητα. Το ταμπλό ανακατεύεται σχεδόν αμέσως μετά την τελευταία κίνηση.',
  htTouchTitle: 'Η οθόνη αφής',
  htTouchBody:
    'Αγγίξτε ένα αναποδογυρισμένο πλακίδιο για να πάρετε το γράμμα του. Αγγίξτε οποιοδήποτε γράμμα έχετε πάρει για να το δώσετε πίσω. Η Υποβολή και ο Καθαρισμός βρίσκονται κάτω από το ταμπλό.',

  accountTitle: 'Ο λογαριασμός σου',
  menuProfile: 'Το προφίλ μου',
  menuGames: 'Τα παιχνίδια μου',
  menuPublicPage: 'Η δημόσια σελίδα μου',
  menuSignedInAs: 'Συνδεδεμένος ως',
  signIn: 'Σύνδεση',
  signOut: 'Αποσύνδεση',
  signInTitle: 'Συνδέσου ή δημιούργησε λογαριασμό',
  signInLead: 'Ένας λογαριασμός κρατά τα παιχνίδια σου, σε κάθε συσκευή.',
  signInKeepGame: 'Συνδέσου για να κρατήσεις αυτό το παιχνίδι, και όλα τα επόμενα.',
  continueWithApple: 'Συνέχεια με Apple',
  continueWithGoogle: 'Συνέχεια με Google',
  signInOr: 'ή',
  emailLabel: 'E-mail',
  codeLabel: 'Κωδικός',
  emailMeACode: 'Στείλτε μου έναν κωδικό',
  working: 'Μια στιγμή…',
  sendNewCode: 'Αποστολή νέου κωδικού',
  codeSent: 'Δες το e-mail σου. Ο κωδικός κρατά 10 λεπτά.',
  notNow: 'Όχι τώρα',
  badEmail: 'Αυτό δεν μοιάζει με διεύθυνση e-mail.',
  badCode: 'Ο κωδικός δεν δούλεψε. Οι κωδικοί λήγουν σε 10 λεπτά και χρησιμοποιούνται μία φορά.',
  serverBusy: 'Ο διακομιστής δεν απαντά. Δοκίμασε σε λίγο.',
  serverDown: 'Ο διακομιστής δεν απαντά.',
  offline: 'Εκτός σύνδεσης',
  leaderboardTitle: 'Κατάταξη',
  leaderboardEmpty: 'Δεν υπάρχουν ακόμη παιχνίδια σε αυτήν την κατάταξη. Γίνε ο πρώτος.',
  leaderboardWouldBe: 'Πού θα έμπαινε αυτό το παιχνίδι',
  leaderboardThisGame: 'Αυτό το παιχνίδι',
  leaderboardRanksHere: 'Πού μπαίνει αυτό το παιχνίδι',
  leaderboardOutside: 'Εκτός πρώτης πεντάδας.',
  tutAccountTitle: 'Κρατήστε τα σκορ σας',
  tutAccountBody:
    'Ένας λογαριασμός κρατά τα παιχνίδια σας, βάζει τα σκορ σας στην κατάταξη και διατηρεί το προφίλ σας.',
  ssoCancelled: 'Η σύνδεση ακυρώθηκε.',
  ssoExpired: 'Άργησε πολύ. Συνδέσου ξανά.',
  ssoNoUsername: 'Ο λογαριασμός δεν ολοκληρώθηκε. Δοκίμασε σε λίγο.',
  ssoFailed: 'Δεν δούλεψε. Δοκίμασε ξανά, ή χρησιμοποίησε το e-mail σου.',
  tabProfile: 'Προφίλ',
  countryAny: 'Δεν λέω',
  findCountry: 'Αναζήτηση χωρών',
  usernameLabel: 'Όνομα χρήστη',
  bioLabel: 'Λίγα λόγια',
  countryLabel: 'Χώρα',
  bioHint: 'Χωρίς συνδέσμους. {left}/{max}',
  save: 'Αποθήκευση',
  saving: 'Αποθήκευση…',
  saved: 'Αποθηκεύτηκε.',
  nameTaken: 'Κάποιος έχει ήδη αυτό το όνομα.',
  nameTooShort: 'Λίγο μεγαλύτερο, παρακαλώ.',
  nameTooLong: 'Είναι πολύ μεγάλο.',
  nameBadCharacters: 'Μόνο γράμματα, ψηφία, παύλες και κάτω παύλες.',
  nameBadEdges: 'Πρέπει να αρχίζει και να τελειώνει με γράμμα ή ψηφίο.',
  nameMixedScripts: 'Διάλεξε ένα αλφάβητο και μείνε σε αυτό.',
  nameReserved: 'Μοιάζει με όνομα που δίνουμε εμείς. Διάλεξε άλλο.',
  nameUnusable: 'Αυτό το όνομα δεν μπορεί να χρησιμοποιηθεί.',
  bioTooLong: 'Τα λίγα λόγια χωρούν το πολύ {max} χαρακτήρες.',
  bioHasLink: 'Δεν επιτρέπονται σύνδεσμοι εδώ.',
  bioHasControl: 'Περιέχει χαρακτήρες που δεν χωρούν εδώ.',
  bioUnusable: 'Αυτό το κείμενο δεν μπορεί να χρησιμοποιηθεί.',
  gamesHeading: 'Παιχνίδια',
  gamesEmpty: 'Δεν υπάρχει τίποτα ακόμα. Τα παιχνίδια που παίζεις συνδεδεμένος θα φαίνονται εδώ.',
  gamesEmptyShort: 'Δεν υπάρχει τίποτα ακόμα.',
  gamesLoading: 'Διαβάζω τα παιχνίδια σου…',
  theirGamesLoading: 'Διαβάζω τα παιχνίδια τους…',
  profileLoading: 'Διαβάζω το προφίλ…',
  playerNotFound: 'Δεν υπάρχει κανείς εδώ με αυτό το όνομα.',
  columnWhen: 'Πότε',
  columnRounds: 'γύροι',
  columnGame: 'Παιχνίδι',
  gameLoading: 'Διαβάζω το παιχνίδι…',
  gameUnreadable: 'Αυτό το παιχνίδι δεν διαβάστηκε.',
  gameNotRanked: 'Παίχτηκε με αλλαγμένους κανόνες, οπότε δεν κατατάσσεται.',
  detailNotKept: 'Οι λέξεις και τα ταμπλό αυτού του παιχνιδιού δεν κρατιούνται πια.',
  openingBoard: 'Το αρχικό ταμπλό',
  roundByRound: 'Γύρο με γύρο',
  roundNothing: 'δεν βρέθηκε τίποτα',
  changeReplaced: '{letter} αντικαταστάθηκε στη θέση {slot}',
  changeWildOn: '{letter} μπαλαντέρ στη θέση {slot}',
  changeWildOff: '{letter} μπαλαντέρ έφυγε από τη θέση {slot}',
  keepThisGame: 'Κράτα αυτό το παιχνίδι',
  savedToYourGames: 'Αποθηκεύτηκε στα παιχνίδια σου.',

  reportThis: 'Αναφορά',
  reportHeading: 'Αναφορά αυτού',
  reportTheName: 'Το όνομα',
  reportTheBio: 'Η περιγραφή',
  reportTheScore: 'Το σκορ',
  reportWhy: 'Τι πάει λάθος με αυτό; Προαιρετικό.',
  reportSend: 'Αποστολή αναφοράς',
  reportSent: 'Ευχαριστούμε. Κάποιος θα το δει.',
  reportSignIn: 'Συνδέσου για να αναφέρεις κάτι.',
  reportGone: 'Αυτό δεν υπάρχει πια.',
  reportCancel: 'Άκυρο',

  deleteAccount: 'Διαγραφή του λογαριασμού μου',
  deleteAccountWhat:
    'Αυτό αφαιρεί το προφίλ σου και κάθε παιχνίδι που κράτησες, οριστικά. Δεν αναιρείται.',
  deleteAccountAsk: 'Στείλε μου κωδικό',
  deleteConfirm: 'Διαγραφή οριστικά',
  deleteGone: 'Ο λογαριασμός σου χάθηκε. Ευχαριστούμε που έπαιξες.',
  deleteNoAddress:
    'Δεν υπάρχει επιβεβαιωμένη διεύθυνση σε αυτόν τον λογαριασμό, οπότε η διαγραφή δεν μπορεί να ελεγχθεί. Επικοινώνησε μαζί μας και θα το κάνουμε με το χέρι.',

  rulesetFacts: 'Λέξεις από {letters} · νέο πλακίδιο κάθε {seconds}',
  plurals: {
    words: { one: '{n} λέξη', other: '{n} λέξεις' },
    rounds: { one: '{n} γύρος', other: '{n} γύροι' },
    flips: { one: '{n} κίνηση', other: '{n} κινήσεις' },
    ticks: { one: '{n} χτύπος', other: '{n} χτύποι' },
    points: { one: '{n} βαθμός', other: '{n} βαθμοί' },
    minLetters: { one: '{n} γράμμα και πάνω', other: '{n} γράμματα και πάνω' },
    seconds: { one: '{n} δευτερόλεπτο', other: '{n} δευτερόλεπτα' },
  },
}
